import { DeviceFwUpdateInfo } from './device-fw-update-info.model';

export class CommCardFwUpdateInfo extends DeviceFwUpdateInfo
{
    constructor(json: any = null)
    {
        super(json);

        if (json)
        {
        }
    }

    UId: string;
}
